var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.246 5.316C2.58497 4.92297 2.98348 4.58554 3.427 4.316L9.427 0.715998C10.2036 0.248376 11.093 0.00128174 11.9995 0.00128174C12.906 0.00128174 13.7954 0.248376 14.572 0.715998L20.572 4.316C21.016 4.58527 21.4149 4.92273 21.754 5.316L12 11.169L2.246 5.316ZM13 12.9V23.889C13.5542 23.7796 14.0858 23.5767 14.572 23.289L20.572 19.689C21.3109 19.2427 21.9224 18.6137 22.3477 17.8625C22.7729 17.1113 22.9976 16.2632 23 15.4V8.6C22.9964 8.0749 22.9094 7.55372 22.742 7.056L13 12.9ZM11 12.9L1.258 7.056C1.09065 7.55372 1.00356 8.0749 1 8.6V15.4C1.00248 16.2629 1.22706 17.1107 1.65212 17.8617C2.07719 18.6127 2.68843 19.2417 3.427 19.688L9.427 23.288C9.91353 23.5757 10.4454 23.7786 11 23.888V12.9Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/dictionary.5de784cc.svg";
export { ForwardRef as ReactComponent };